<template>
  <v-row>
    <v-col>
      <v-card>
        <v-expansion-panels multiple>
          <v-expansion-panel v-test="{ panel: '' }">
            <v-expansion-panel-header>
              <div id="info">
                <v-icon>
                  info
                </v-icon>
                {{ $t('Общая информация') }}
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content eager>
              <v-row class="text-left pl-3">
                <text-view
                    :display="organization.organizationShortName"
                    multiline
                    md="6"
                    :label="$t('Короткое наименование')" />
                <text-view
                    :display="organization.organizationFullName"
                    multiline
                    md="6"
                    :label="$t('Полное наименование')" />
                <text-view
                    :display="$t(PARTICIPANT_TYPE_ENUM[organization.participantType])"
                    multiline
                    md="6"
                    :label="$t('Категория участия')" />
                <text-view
                    :display="$t(ORGANIZATION_TYPE_ENUM[organization.organizationType])"
                    multiline
                    md="6"
                    :label="$t('Тип организации')" />
                <!-- <date-view
                    multiline
                    md="6"
                    :display="organization.registrationDate"
                    :label="$t('Дата государственной регистрации юридического лица')" /> -->
                <text-view
                    v-if="!isLoading"
                    multiline
                    md="6"
                    :display="organization.country"
                    :label="$t('Страна')" />
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel v-if="isIndividual" v-test="{ panel: '' }">
            <v-expansion-panel-header>
              <div id="person">
                <v-icon>
                  person
                </v-icon>
                {{ $t('Документ, удостоверяющий личность физ. лица') }}
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content eager>
              <v-row class="text-left pl-3">
                <text-view
                    :display="$t(DOCUMENT_PERSON_IDENTITY_TYPES_ENUM[organization.documentPersonIdentityType])"
                    multiline
                    md="6"
                    :label="$t('Тип документа, удостоверяющего личность физ. лица')" />
                <date-view
                    :display="organization.personBirthdate"
                    multiline
                    md="6"
                    :label="$t('Дата рождения физ. лица')" />
                <text-view
                    :display="organization.documentPersonIdentity"
                    multiline
                    md="6"
                    :label="$t('Серия и номер документа')" />
                <text-view
                    :display="organization.documentPersonIdentityIssued"
                    multiline
                    md="6"
                    :label="$t('Кем и когда был выдан документ')" />
                <text-view
                    :display="organization.personRegistrationAddress"
                    multiline
                    md="6"
                    :label="$t('Адрес регистрации физ. лица')" />
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel v-test="{ panel: '' }">
            <v-expansion-panel-header>
              <div id="manager">
                <v-icon>
                  person
                </v-icon>
                {{ $t('Единоличный исполнительный орган') }}
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content eager>
              <v-row class="text-left pl-5">
                <validatable-checkbox
                    id="isEIO"
                    v-test="{ checkbox: 'isEIO' }"
                    :value="organization.isEIO"
                    :readonly="true"
                    :label="$t('Регистрация от имени единоличного исполнительного органа')" />
              </v-row>
              <v-row class="text-left pl-3">
                <text-view
                    :display="organization.managerFIO"
                    multiline
                    md="6"
                    :label="$t('Руководитель (ФИО)')" />
                <text-view
                    :display="organization.managerPosition"
                    multiline
                    md="6"
                    :label="$t('Должность руководителя')" />
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel v-test="{ panel: '' }">
            <v-expansion-panel-header>
              <div id="business">
                <v-icon>
                  business
                </v-icon>
                {{ $t('Реквизиты') }}
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content eager>
              <v-row class="text-left pl-3">
                <text-view
                    :display="organization.inn"
                    multiline
                    md="6"
                    :label="$t('ИНН')" />
                <text-view
                    :display="organization.ogrn"
                    multiline
                    md="6"
                    :label="$t('ОГРН')" />
                <text-view
                    v-if="showKpp"
                    :display="organization.kpp"
                    multiline
                    md="6"
                    :label="$t('КПП')" />
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel v-test="{ panel: '' }">
            <v-expansion-panel-header>
              <div id="contact_mail">
                <v-icon>
                  contact_mail
                </v-icon>
                {{ $t('Контактная информация') }}
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content eager>
              <v-row class="text-left pl-3">
                <text-view
                    :display="organization.postAddress"
                    multiline
                    md="6"
                    :label="$t('Почтовый адрес')" />
                <text-view
                    multiline
                    md="6"
                    :display="organization.contactPerson"
                    :label="$t('Контактное лицо (ФИО)')" />
                <text-view
                    :display="organization.realAddress"
                    multiline
                    md="6"
                    :label="$t('Фактический адрес')" />
                <text-view
                    :display="organization.phone"
                    multiline
                    md="6"
                    :label="$t('Контактный телефон')" />
                <text-view
                    :display="organization.location"
                    multiline
                    md="6"
                    :label="$t('Юридический адрес')" />
                <text-array-view
                    md="6"
                    :display="organization.email"
                    :label="$t('Адрес электронной почты')" />
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <slot name="additional" />
        </v-expansion-panels>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>

  import TextView from '@/components/reused/ui/TextView.vue'
  import TextArrayView from '@/components/reused/ui/TextArrayView.vue'
  import DateView from '@/components/reused/ui/DateView.vue'
  import ValidatableCheckbox from '@/components/reused/ui/ValidatableCheckbox.vue'

  import {
    PARTICIPANT_TYPE_ENUM,
    ORGANIZATION_TYPE_ENUM,
    DOCUMENT_PERSON_IDENTITY_TYPES_ENUM
  } from '@/constants/enums'
  import { ORGANIZATION_TYPES, DICTIONARY_TYPES, RUSSIAN_COUNTRY_ID } from '@/constants/business'
  import { mapActions, mapState } from 'vuex'
  import { DICTIONARIES } from '@/constants/store.js'

  export default {
    components: {
      TextView,
      TextArrayView,
      DateView,
      ValidatableCheckbox
    },
    props: {
      organizationInfo: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        DICTIONARY_TYPES,
        ORGANIZATION_TYPE_ENUM,
        PARTICIPANT_TYPE_ENUM,
        DOCUMENT_PERSON_IDENTITY_TYPES_ENUM,
        isLoading: false
      }
    },
    computed: {
      ...mapState(DICTIONARIES.NAMESPACE, {
        countries: state => (state[DICTIONARIES.STATE.COUNTRIES] || [])
      }),
      organization () {
        const org = this.organizationInfo
        const documentPersonIdentity = org.documentPersonIdentity
          ? `${org.documentPersonIdentity.substring(0, 4)} ${org.documentPersonIdentity.substring(4)}`
          : null
        return {
          ...org,
          email: org.email
            ? org.email.split(';').filter(str => !!str.trim().length)
            : [],
          country: this.countries.find(o => o.key === org.country?.toString())?.value || '',
          documentPersonIdentity
        }
      },
      isIndividual () {
        return this.organization.organizationType === ORGANIZATION_TYPES.INDIVIDUAL
      },
      showKpp () {
        return !this.isIndividual &&
          this.organizationInfo.country === RUSSIAN_COUNTRY_ID
      }
    },
    created () {
      if (!this.countries.length) {
        this.getDictionaryItems()
      }
    },
    methods: {
      ...mapActions(DICTIONARIES.NAMESPACE, {
        getIdentityDictionaryItemsAction: DICTIONARIES.ACTIONS.GET_IDENTITY_DICTIONARY_ITEMS
      }),
      getDictionaryItems: async function () {
        try {
          this.isLoading = true
          await this.getIdentityDictionaryItemsAction({
            dictionaryType: DICTIONARY_TYPES.COUNTRIES
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      }
    }
  }
</script>
